<div #alert class="alert pk-alert-banner alert-dismissible fade text-center" [ngClass]="getClass" role="alert" *ngIf="!loading">
	<p class="mb-0 font-size-1">
		<span [innerHtml]="bannerType.bannerHeaderHtml"></span>
		<a
			href="javascript:void(0)"
			role="button"
			class="btn btn-banner btn-sm mx-2"
			(click)="bannerType.onActionClicked()"
			id="topBannerAlertLearnMoreBtn"
			>Learn More</a
		>
	</p>
	<button type="button" class="close align-self-center" (click)="hideAlert()" id="topBannerAlertCloseBtn">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
